module.exports = __webpack_public_path__ + "assets/img/discountCouponIcon.c0b63169.png";